module.exports = __webpack_public_path__ + "img/иллюстрация данные.4a0b2a19.svg";